var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9976 12.9986C25.9976 16.6895 23 20 23 20C23 20 17.0893 16.9997 13 17C8.91175 17.0003 3 20 3 20C3 20 0 16.6898 0 12.9986C0 5.81935 5.81935 0 12.9986 0C20.1778 0 25.9976 5.81935 25.9976 12.9986ZM12.999 14.2984C15.8706 14.2984 18.1984 11.9706 18.1984 9.09894C18.1984 6.22731 15.8706 3.89951 12.999 3.89951C10.1274 3.89951 7.79958 6.22731 7.79958 9.09894C7.79958 11.9706 10.1274 14.2984 12.999 14.2984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9986 24.6973C19.4597 24.6973 24.6974 19.4596 24.6974 12.9984C24.6974 6.53733 19.4597 1.29958 12.9986 1.29958C6.53744 1.29958 1.29969 6.53733 1.29969 12.9984C1.29969 19.4596 6.53744 24.6973 12.9986 24.6973ZM12.9986 25.9971C20.1778 25.9971 25.9971 20.1778 25.9971 12.9986C25.9971 5.81935 20.1778 0 12.9986 0C5.81935 0 0 5.81935 0 12.9986C0 20.1778 5.81935 25.9971 12.9986 25.9971Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.719995c141ddfc6173e117dae5f2be49.svg";
export { ForwardRef as ReactComponent };